import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Grid,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  useTheme,
  Button,
  Dialog,
} from "@mui/material";
import { TrashIcon, PlusIcon, PenIcon } from "../components/svgicons/SvgIcons";
import FancyTooltip from "../components/utils/FancyTooltip";
import FancyPaper from "../components/FancyPaper";
import { useForm } from "react-hook-form";
import {
  createRequest,
  updateRequest,
  deleteRequest,
  getRequestList,
} from "../services/subfamilies/SubFamilyService";
import { useApp } from "../hooks/useApp";
import DeleteModal from "../components/utils/DeleteModal";
import FancyTablePagination from "../components/utils/FancyTablePagination";
import FancyDialogActions from "../components/utils/FancyDialogActions";
import AddOrUpdateSubFamilyModal from "../components/utils/AddOrUpdateSubFamilyModal";
import FancySearch from "../components/utils/FancySearch";

const ManagementSubFamilies = () => {
  //const { id } = useParams();
  const {
    authInfo,
    setLoading,
    setErrorMsg,
    modalData,
    setModalData,
    setSuccessMsg,
    errorMsg,
  } = useApp();
  const theme = useTheme();
  const [familyData, setFamilyData] = useState<any>([]);
  const { id, familyName } = useParams<{ id: string; familyName: string }>();
  const familyId = Number(id);
  const [page, setPage] = useState(0);
  const [preFilter, setPreFilter] = useState<any>("");
  const { handleSubmit } = useForm();
  console.log("Families id ", familyId);
  /**
   * Efecto inicial para carga de registros
   */
  useEffect(() => {
    const dataInit = async () => {
      await handleFetchData(familyId, 0, "");
    };
    dataInit();

    // eslint-disable-next-line
  }, []);

  /**
   * Metodo encargado de buscar registros
   * @param filter
   * @param currentPage
   */
  const handleFetchData = async (
    familyId: number,
    currentPage: number,
    filter: string,
    applyRole?: any
  ) => {
    setLoading && setLoading(true);
    setFamilyData([]);
    try {
      setPage(currentPage);
      let data = await getRequestList(familyId, filter, currentPage, 10);
      console.log("data", data);
      if (data) {
        setFamilyData(data);
      }
      setLoading && setLoading(false);
    } catch (error: any) {
      setLoading && setLoading(false);
      setErrorMsg && setErrorMsg(error.message);
      console.log(error);
    }
  };
  /* 
  const handleFetchByID = async (id: string) => {
    setLoading && setLoading(true);
    try {
      let roleData = await findByIdRequest(id);
      //@ts-ignore
      if (roleData && roleData?.content?.id > 0) {
        //@ts-ignore
        setFormData(roleData.content);
      }
      setLoading && setLoading(false);
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  }; */

  /**
   * Metodo encargado de crear registro
   * @param data
   */
  const handleAdd = async (data: any) => {
    data.idFamily = familyId;
    handleCancelModal();
    setLoading && setLoading(true);
    try {
      let createData = await createRequest({
        ...data,
        userCreated: authInfo?.username,
        user: authInfo?.username,
      });

      if (!createData) {
        setErrorMsg && setErrorMsg("Error creando la SubFamilia de productos");
        setLoading && setLoading(false);
        console.log("no se envia");
        return;
      }
      setLoading && setLoading(false);
      setSuccessMsg && setSuccessMsg("SubFamilia creada correctamente");
      console.log("se envio");
      //call fetch data
      await handleFetchData(familyId, 0, "");
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
      console.log(error);
    }
  };

  /**
   * Metodo encargado de actualizar registro
   * @param data
   */
  const handleUpdate = async (data: any) => {
    console.log("data = ", data);
    data.idFamily = familyId;
    handleCancelModal();
    setLoading && setLoading(true);
    try {
      let updateData = await updateRequest({
        ...data,
        userModified: authInfo?.username,
        user: authInfo?.username,
        idFamily: familyId,
      });

      if (!updateData) {
        setErrorMsg &&
          setErrorMsg("Error actualizando SubFamilia de productos");
        setLoading && setLoading(false);
        return;
      }
      setLoading && setLoading(false);
      setSuccessMsg && setSuccessMsg("SubFamilia actualizada correctamente");
      //call fetch data
      await handleFetchData(familyId, 0, "");
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  };

  /**
   * Metodo encargado de eliminar registro
   * @param data
   */
  const handleDelete = async (id: any) => {
    handleCancelModal();
    setLoading && setLoading(true);
    try {
      let deleteData = await deleteRequest(id);
      if (!deleteData) {
        setErrorMsg && setErrorMsg("Error eliminando SubFamilia");
        setLoading && setLoading(false);
        return;
      }
      setLoading && setLoading(false);
      setSuccessMsg && setSuccessMsg("SubFamilia eliminada correctamente");
      //reset page and call fetch data
      await handleFetchData(familyId, 0, "");
    } catch (error: any) {
      setErrorMsg && setErrorMsg(error.message);
      setLoading && setLoading(false);
    }
  };

  /**
   * Efecto para validar errores en caso de abrir modal
   */
  useEffect(() => {
    if (modalData && modalData?.modalOpen && errorMsg) {
      setModalData &&
        setModalData({
          modalOpen: false,
          modalType: "",
          modalObject: null,
        });
    }
  }, [modalData, errorMsg, setModalData]);

  /**
   * Evento de apertura de modal
   */
  const handleOpenModal = async (event: any) => {
    event.preventDefault();
    const modalAction = event.currentTarget.getAttribute("data-name");
    let object = null;
    const id = event.currentTarget.getAttribute("data-id");
    if (modalAction === "update") {
      object = familyData.content.find((p: any) => p.id === parseInt(id));
    }

    if (modalAction === "delete") {
      object = familyData.content.find((p: any) => p.id === parseInt(id));
    }

    //open modal
    setModalData &&
      setModalData({
        ...modalData,
        modalOpen: true,
        modalType: modalAction,
        modalObject: object,
      });
  };

  const handleApplyFilter = async () => {
    if (preFilter !== "") {
      await handleFetchData(familyId, 0, preFilter);
    }
  };

  /**
   * @param event
   */
  const handleCancelModal = () => {
    setModalData &&
      setModalData({
        ...modalData,
        modalOpen: false,
        modalType: "",
        modalObject: null,
      });
  };

  const onSubmit = async (data: any) => {
    switch (modalData?.modalType) {
      case "create":
        await handleAdd(data);
        break;
      case "update":
        await handleUpdate(data);
        break;
      case "delete":
        //@ts-ignore
        await handleDelete(modalData?.modalObject?.id);
        break;
      default:
        break;
    }
  };

  const handleChangePage = async (event: unknown, newPage: number) => {
    const customPage = newPage - 1;
    setPage(customPage);
    if (customPage !== page) {
      await handleFetchData(familyId, customPage, preFilter);
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPage(0);
  };
  return (
    <>
      <FancyPaper
        pagetitle={familyName}
        prevpage="Familia"
        linkprevpage="/dashboard/families"
      >
        <Grid container spacing={8} sx={{ pb: 8 }}>
          <Grid item md={7} sm={5} xs={12}>
            {/* <ResourceAccess isCode={true} pathOrCode={"ROLE:WRITE"}> */}
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenModal}
              data-name="create"
            >
              {"Agregar SubFamilia"}
              <PlusIcon sx={{ ml: 1 }} />
            </Button>
            {/* </ResourceAccess> */}
          </Grid>
          <Grid item md={5} sm={7} xs={12}>
            <FancySearch
              preFilter={preFilter}
              setPreFilter={setPreFilter}
              handleFetchData={() => handleFetchData(familyId, 0, "")}
              handleApplyFilter={handleApplyFilter}
            />
          </Grid>
        </Grid>
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell align="center">{"Nombre"}</TableCell>
                <TableCell align="center">{"Descripción"}</TableCell>
                <TableCell align="center">{"Código de familia"}</TableCell>
                <TableCell align="center">{"Acciones"}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {familyData &&
                familyData.content &&
                familyData.content.map((row: any, i: number) => (
                  <TableRow
                    key={i}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell scope="row">{row.id}</TableCell>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{row.description}</TableCell>
                    <TableCell align="center">{row?.family.code}</TableCell>
                    <TableCell align="center">
                      {/*<ResourceAccess isCode={true} pathOrCode={"ROLE:WRITE"}>*/}
                      <FancyTooltip
                        title={"Agregar SubSubamilias"}
                        placement="top"
                      >
                        <Link
                          to={
                            "/dashboard/subfamilies/" +
                            id +
                            "/" +
                            familyName +
                            "/subsubfamilies/" +
                            row.id +
                            "/" +
                            row.name
                          }
                        >
                          <IconButton
                            aria-label="edit"
                            component="label"
                            color="secondary"
                            sx={{
                              "&:hover": {
                                color: theme.palette.secondary.dark,
                              },
                            }}
                            data-name="update"
                            data-id={row.id}
                          >
                            <PlusIcon />
                          </IconButton>
                        </Link>
                      </FancyTooltip>

                      <FancyTooltip title={"Editar"} placement="top">
                        <IconButton
                          aria-label="edit"
                          component="label"
                          color="primary"
                          onClick={handleOpenModal}
                          data-name="update"
                          data-id={row.id}
                        >
                          <PenIcon />
                        </IconButton>
                      </FancyTooltip>

                      <FancyTooltip title={"Eliminar"} placement="top">
                        <IconButton
                          aria-label="trash"
                          component="label"
                          color="error"
                          sx={{
                            "&:hover": {
                              color: theme.palette.error.dark,
                            },
                          }}
                          data-id={row.id}
                          onClick={handleOpenModal}
                          data-name="delete"
                        >
                          <TrashIcon />
                        </IconButton>
                      </FancyTooltip>
                      {/*</ResourceAccess>*/}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <FancyTablePagination
          count={
            familyData.content?.length > 0 ? familyData.content?.length : 0
          }
          rowsPerPage={familyData.size}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalElements={familyData.totalElements}
          totalPages={familyData.totalPages}
        />
      </FancyPaper>
      {(modalData?.modalType === "create" ||
        modalData?.modalType === "update") && (
        <Dialog
          open={modalData.modalOpen}
          onClose={handleCancelModal}
          fullWidth
        >
          <AddOrUpdateSubFamilyModal
            data={modalData?.modalObject}
            onSubmit={onSubmit}
            cancelModal={handleCancelModal}
            modalType={modalData?.modalType}
          />
        </Dialog>
      )}
      {modalData?.modalType === "delete" && (
        <Dialog
          open={modalData.modalOpen}
          onClose={handleCancelModal}
          fullWidth
        >
          <DeleteModal
            //@ts-ignore
            textChildren={modalData?.modalObject?.username}
            actionButton={
              <>
                <FancyDialogActions
                  handleAccept={handleSubmit(onSubmit)}
                  cancelModal={handleCancelModal}
                  textAcceptButton={"Eliminar"}
                />
              </>
            }
          />
        </Dialog>
      )}
    </>
  );
};

export default ManagementSubFamilies;
